import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F68.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame68() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F68_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F68_entryBox">
                    <div className="F68_paragraph">
                        {language === 'english' ?
                            <p className="F68_paragraphEnglish">After this argument the girls had nothing else to add. It looked like Saira has made them speechless. Surprisingly one of the senior girls among the four came forward and hug Saira unexpectedly. She asked Saira to be friends with her so that they can learn more from her. Saira accepted the offer; she was happy that she could make this breakthrough with the senior girls</p>
                            :
                            <p className="F68_paragraphUrdu">اس دلیل کے بعد جیسے لڑکیوں کو چپ لگ گئی ہو اور ان کے پاس کہنے کے لئے اور کچھ نہ بچا ہو۔ اچانک ان میں سے ایک لڑکی آگے بڑھ کر سائرا کو گلے لگاتی ہے ۔ وہ سائرا کو اپنا دوست بنانا چاہتی ہے  تا کہ اس سے مزید بھی سیکھ سکے۔ سائرا نئے دوست بنا کر بہت خوش ہے اور اس سے بڑھ کر یہ کہ وہ اپنی بات ان کو سمجھا سکی ہے۔</p>
                        }
                    </div>

                    <div className="F68_timeline">
                        <div className='F68_timelineBar'>
                            <div className='F68_timelineFill'></div>
                            <span className='F68_timelineText'>14/14</span>
                        </div>
                    </div>

                    <div className="F68_nextFrames">
                        <div className="F68_nextFrame1"></div>
                    </div>

                    <div className='F68_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(14)) }} className='F68_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame68;